import { Component } from '@angular/core';

@Component({
	selector: 'cc-unauthenticated-layout',
	templateUrl: './unauthenticated-layout.component.html',
	styleUrls: ['./unauthenticated-layout.component.css']
})
export class UnauthenticatedLayoutComponent {

}